<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-date-input
                        prepend-inner-icon="mdi-calendar"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="lead_date.value.value"
                        :error-messages="lead_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Create Date
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>
                      <v-autocomplete
                        label="Work Order Lead"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="lead_id.value.value"
                        :items="getSchema"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onLeadChange"
                        :error-messages="lead_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_name.value.value"
                        :error-messages="contact_name.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Contact Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Contact Email"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_email.value.value"
                        :error-messages="contact_email.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Contact Email
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Contact Mobile"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_number.value.value"
                        :error-messages="contact_number.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Contact Phone
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Contact Designation"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_designation.value.value"
                        :error-messages="contact_designation.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Contact Designation
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Memorandum of Understanding (MOU)
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form ref="addLetter" id="addLetter">
                  <v-row class="pt-2">
                    <v-col cols="12">
                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Subject</v-label
                        >
                        <v-text-field
                          label="Subject"
                          class="visually-hidden-label"
                          density="compact"
                          single-line
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="subject.value.value"
                          :error-messages="subject.errorMessage.value"
                          autocomplete="off"
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Project Details</v-label
                        >
                        <Ckeditor
                          :editor="ClassicEditor"
                          v-model="project_details.value.value"
                          :config="editorConfig"
                        />
                      </v-col>
                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Terms & Conditions</v-label
                        >
                        <Ckeditor
                          :editor="ClassicEditor"
                          v-model="terms_conditions.value.value"
                          :config="editorConfig"
                        />
                      </v-col>
                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Signature</v-label
                        >
                        <Ckeditor
                          :editor="ClassicEditor"
                          v-model="regards.value.value"
                          :config="editorConfig"
                        />
                      </v-col>

                      <v-col cols="8">
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Description</v-label
                        >
                        <v-textarea
                          label="Description"
                          class="visually-hidden-label"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            @click="submitForm(0)"
                            >DRAFT</v-btn
                          >
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
  components: {
    Ckeditor,
  },
  data: () => ({
    panel: [0],
    loading: false,
  }),
  created() {
    if (this.$store.getters.getSalesLeads.length === 0) {
      this.$store.dispatch("getSalesLeads");
    }
  },
  computed: {
    getSalesLeads() {
      return this.$store.getters.getSalesLeads;
    },
    getSchema() {
      const workOrder = this.$store.getters.getSalesLeads.filter(
        (e) => e.lead_action.name === "Work Order"
      );
      return workOrder;
    },
  },
  methods: {
    async onLeadChange(selectedId) {
      if (!selectedId) {
        this.contact_name.value.value = "";
        this.contact_email.value.value = "";
        this.contact_number.value.value = "";
        this.contact_designation.value.value = "";
        return;
      }
      try {
        const response = await this.$store.dispatch(
          "getSalesLeadsById",
          selectedId
        );
        const data = response.data;
        this.contact_name.value.value = data.contact_name || "";
        this.contact_email.value.value = data.contact_email || "";
        this.contact_number.value.value = data.contact_number || "";
        this.contact_designation.value.value = data.contact_designation || "";
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.log(error);
      }
    },
    submitForm(status) {
      this.letter_id = status;
      this.submit();
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        subject: yup.string().required().label("Subject"),
        project_details: yup.string().required().label("Project Details"),
        terms_conditions: yup.string().required().label("Terms & Conditions"),
        regards: yup.string().required().label("Regards"),
      }),
    });

    const lead_date = useField("lead_date");
    const lead_id = useField("lead_id");
    const contact_name = useField("contact_name");
    const contact_email = useField("contact_email");
    const contact_number = useField("contact_number");
    const contact_designation = useField("contact_designation");
    const subject = useField("subject");
    const project_details = useField("project_details");
    const terms_conditions = useField("terms_conditions");
    const regards = useField("regards");
    const letter_id = ref("1");
    const remarks = useField("remarks");

    const submit = handleSubmit((values) => {
      const payload = {
        ...values,
        id: letter_id.value,
      };
      store
        .dispatch("saveUpdatePurLetterInfo", payload)
        .then((response) => {
          resetForm();
          toast.success(response.data.message, { timeout: 3000 });
          setTimeout(() => router.push({ name: "add-rfq" }), 2000);
        })
        .catch((error) => {
          const message =
            error.response?.data?.message || "Failed to update letter";
          toast.error(message);
        });
    });

    return {
      lead_date,
      lead_id,
      contact_name,
      contact_email,
      contact_number,
      contact_designation,
      subject,
      project_details,
      terms_conditions,
      regards,
      submit,
      letter_id,
      remarks,
      ClassicEditor,
    };
  },
};
</script>

<style>
.visually-hidden-label .v-field-label {
  display: none !important;
}

.panel-header {
  font-weight: bold;
  font-size: 1.1rem;
}
</style>
